import { useTranslation } from "react-i18next";
import SelectInput from "../../components/form/SelectInput";
import FormField from "../../components/form/FormField";
import TextInput from "../../components/form/TextInput";
import Button from "../../components/form/Button";
import Checkbox from "../../components/form/Checkbox";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import claimSchema from "../../validation/claimSchema";
import toast from "react-hot-toast";
import { getClaimDetail, submitBookingClaim } from "../../shared/queries";
import { ClaimDetail, OpenClaimResponse } from "../../types";
import { useQuery } from "react-query";
import dayjs from "dayjs";
import { fileListToBase64, formatCurrency } from "../../shared/utils";
import Uppy from "@uppy/core";
import { Dashboard } from "@uppy/react";

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import ReactTooltip from "react-tooltip";

const fileReader = new FileReader()

const ClaimDetails = ({ detail } : { detail: ClaimDetail }) => {

  const { t } = useTranslation()

  const RenderClaimStatus = () => {
    if (detail.status === 'pending' || detail.status === 'progress' || detail.payoutPending) {
      return (
        <div className="text-slate-600 mt-6 text-lg">
          <div className="mb-2 flex space-x-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
              <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z" clipRule="evenodd" />
            </svg>
            <div className="flex-1">
              <div className="font-bold mb-1">
                {t('openClaim.pendingTitle')}
              </div>
              <div>
                {t('openClaim.pendingText')}
              </div>
              <div className="mt-2">
                {t('openClaim.thankYou')}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (detail.payoutExecuted && detail.payouts.length > 0) {
      return (
        <div className="text-slate-600 mt-6 text-lg">
          <div className="mb-2 flex space-x-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
              <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
            </svg>
            <div className="flex-1">
              <div className="font-bold mb-1">
                {t('openClaim.executedTitle')}
              </div>
              <div>
                {t('openClaim.executedText')}
              </div>
              <div className="mt-4">
                <div className="text-slate-700 font-bold mb-2">
                  {t('openClaim.executedDetail')}
                </div>
                <div>
                  IBAN: {detail.payouts[0].iban} <br/>
                  {t('openClaim.amount')}: {formatCurrency(detail.payouts[0].amount)} <br/>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (detail.payoutRejected) {
      return (
        <div className="text-slate-600 mt-6 text-lg">
          <div className="mb-2 flex space-x-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
              <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z" clipRule="evenodd" />
            </svg>
            <div className="flex-1">
              <div className="font-bold mb-1">
                {t('openClaim.requestRejectTitle')}
              </div>
              <div>
                {t('openClaim.requestRejectText')}
              </div>
              <div className="mt-2">
                {t('openClaim.requestRejectText2')} <a href="mailto:info@refundandgo.com">info@refundandgo.com</a>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return <></>
  }

  return (
    <section className="mt-6 bg-white rounded-lg p-10 flex items-center space-x-12 mb-12">
      <div className="w-44"><img className="w-full" src="/assets/okclaim.svg" alt="Send claim" /></div>
      <div className="flex-1">
        <div className="text-2xl font-bold text-slate-700">
          {t('openClaim.requestReceived')}
        </div>
        <div className="text-lg text-slate-600 mt-1 mb-2">{t('openClaim.weWillReply')} {dayjs(detail.idealCloseDate, 'YYYY-MM-DD').format('dddd DD MMMM YY')}</div>

        <RenderClaimStatus />
      </div>
    </section>
  )
}

export default function OpenClaimPage () {

  const [uppy] = useState(() => new Uppy())

  const history = useHistory()
  const { t } = useTranslation()
  const { code } = useParams<any>()

  const { bookingDetails, loading } = useAppSelector(state => state.guestArea)

  const [sending, setSending] = useState(false)
  const [errors, setErrors] = useState<any>([])

  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [reason, setReason] = useState('')
  const [story, setStory] = useState('')
  const [files, setFiles] = useState<any>([])
  const [privacy, setPrivacy] = useState(false)

  const [claimResponse, setClaimResponse] = useState<OpenClaimResponse | undefined>()

  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const {
    data: claimDetail,
    refetch: refetchClaim
  } = useQuery(['claimDetail', code], () => getClaimDetail(code), {
    onError: (data: ClaimDetail) => {
      setError(data.success)
      setErrorMessage(data.status)
    }
  })

  const CLAIM_OPTIONS = [
    { label: t('openClaim.sick'), value: 'Malattia' },
    { label: t('openClaim.quarantine'), value: 'Quarantena' },
    { label: t('openClaim.pregnancy'), value: 'Gravidanza' },
    { label: t('openClaim.death'), value: 'Decesso' },
    { label: t('openClaim.testimonial'), value: 'Citazione testimoniale' },
    { label: t('openClaim.lostDocs'), value: 'Perdita titoli viaggio' },
    { label: t('openClaim.flightCancellation'), value: 'Cancellazione voli' },
    { label: t('openClaim.hiring'), value: 'Assunzione/Licenziamento' },
    { label: t('openClaim.terrorism'), value: 'Terrorismo' },
    { label: t('openClaim.interruption'), value: 'Interruption' },
    { label: t('openClaim.other'), value: 'Altro' }
  ]

  function getBooker () {
    if (!bookingDetails) return null
    return bookingDetails.booking.guests.find(g => g.isBooker)
  }

  async function handleSendClaim () {
    try {
      setSending(true)
      if (!bookingDetails) return
      const booker = getBooker()
      if (!booker) return

      const body = {
        distributor_code: "ALT",
        firstname: booker.guestFirstName,
        lastname: booker.guestLastName,
        email: email,
        phone: phone,
        reason: reason,
        comment: story,
        files: await handleSetFiles(),
        form_id: 1,
        id_booking: bookingDetails.booking.idBooking
      }

      const { error } = claimSchema.validate(body, {
        abortEarly: false
      })
      if (error) {
        setErrors(error)
        toast.error(t('general.missingFields'))
        return
      }

      if (!privacy) {
        alert(t('openClaim.mandatoryPrivacy'))
        return
      }

      const result = await submitBookingClaim(code, {
        email: email,
        phone: phone,
        reason: reason,
        story: story,
        files: await handleSetFiles()
      })
      if (result.success) {
        refetchClaim()
      }
      setClaimResponse(result)
    } catch (e) {
      console.log(e)
    } finally {
      setSending(false)
    }
  }

  async function handleSetFiles () {
    const filesBase64 = await fileListToBase64(uppy.getFiles().map(uf => uf.data))
    return filesBase64.map((convertedFile: any) => {
      const parts = convertedFile.file.name?.split('.')
      return {
        data: convertedFile.base64String,
        mime: convertedFile.file.type,
        ext: `.${parts[parts.length - 1]}`,
        name: parts.slice(0, -1).join('')
      }
    })
  }

  useEffect(() => {
    if (!bookingDetails || !bookingDetails.booking) return
    const booker = bookingDetails.booking.guests.find(b => b.isBooker)
    if (booker) {
      setEmail(booker.guestEmail)
    }
  }, [ bookingDetails ])

  return (
    <div className="max-w-3xl mx-auto">
      <ReactTooltip />
      <button
        onClick={() => history.push(`/guest-area/${code}`)}
        className="mt-4 rounded-md bg-gray-200 text-gray-700 px-4 py-2 font-medium flex space-x-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
          <path fillRule="evenodd" d="M7.793 2.232a.75.75 0 01-.025 1.06L3.622 7.25h10.003a5.375 5.375 0 010 10.75H10.75a.75.75 0 010-1.5h2.875a3.875 3.875 0 000-7.75H3.622l4.146 3.957a.75.75 0 01-1.036 1.085l-5.5-5.25a.75.75 0 010-1.085l5.5-5.25a.75.75 0 011.06.025z" clipRule="evenodd" />
        </svg>
        <div>
          {t('openClaim.goBack')}
        </div>
      </button>

      {
        (claimDetail && claimDetail.success) &&
        <ClaimDetails detail={claimDetail} />
      }

      {
        (!claimDetail) &&
        <>
          <section className="bg-white rounded-lg my-10">
            <div className="p-8 flex-col md:flex-row flex items-center md:space-y-0 md:space-x-12">
              <div className="order-2 md:order-1 flex-1">
                <div className="text-3xl text-gray-600 mb-4 font-bold">{t('openClaim.sendClaim')}</div>
                <div className="text-gray-600 text-lg">
                  {t('openClaim.subtitle')}
                </div>
              </div>
              <div className="mb-6 md:mb-0 order-1 md:order-2 flex-1 flex items-center justify-center">
                <img style={{ width: '60%' }} src="/assets/guestportal/sendmessage.svg" alt="Send claim" />
              </div>
            </div>
          </section>
          <section className="bg-white rounded-lg my-10">
            <div className="p-8">
              <div className="text-xl font-bold text-gray-600 mb-4">
                {t('openClaim.contactDetails')}
              </div>

              <div className="flex space-y-4 md:space-y-0 md:space-x-4 flex-wrap md:flex-nowrap">
                <div className="w-full md:flex-1">
                  <FormField
                    label={t('openClaim.phone')}
                    errors={errors}
                    errorKey={'phone'}
                  >
                    <TextInput value={phone} type="tel" onChange={val => setPhone(val)} />
                  </FormField>
                </div>

                <div className="w-full md:flex-1">
                  <FormField
                    label="Email"
                    errors={errors}
                    errorKey={'email'}
                  >
                    <TextInput value={email} type="email" onChange={val => setEmail(val)} />
                  </FormField>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-white rounded-lg my-10">
            <div className="p-8">
              <div className="text-xl font-bold text-gray-600 mb-4">
                {t('openClaim.claimDetails')}
              </div>

              <div className="flex flex-col space-y-4">
                <FormField
                  label={t('openClaim.refundReason')}
                  errors={errors}
                  errorKey={'reason'}
                >
                  <SelectInput
                    onChange={(item: any) => {
                      if (item) {
                        setReason(item.value)
                      }
                    }}
                    value={CLAIM_OPTIONS.find(co => co.value === reason)}
                    options={CLAIM_OPTIONS}
                  />
                </FormField>

                <FormField
                  errors={errors}
                  errorKey={'comment'}
                  label={t('openClaim.story')}>
                  <TextInput
                    value={story}
                    type="textarea"
                    onChange={val => setStory(val)}
                  />
                </FormField>

                <FormField
                  errors={errors}
                  errorKey={'files'}
                  label={t('openClaim.uploadFile')}
                >

                  <div className="text-slate-600 border-t pt-6 mt-6">
                      <div className="mb-4">
                        <strong>{t('openClaim.important')}</strong> {t('openClaim.toLetUs')}
                      </div>
                      <ul className="list-disc flex flex-col space-y-1 pt-2 pb-6">
                        <li className="flex space-x-2">
                          <div>{t('openClaim.resConfirm')}</div>
                          <div
                            data-tip={t('openClaim.resConfirmText')}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
                              </svg>
                          </div>
                        </li>
                        <li className="flex space-x-2">
                          <div>{t('openClaim.travelCancellation')}</div>
                          <div
                            data-tip={t('openClaim.travelCancellationText')}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
                              </svg>
                          </div>
                        </li>
                        <li className="flex space-x-2">
                          <div>{t('openClaim.paymentReceipt')}</div>
                          <div
                            data-tip={t('openClaim.paymentReceiptText')}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
                              </svg>
                          </div>
                        </li>
                        <li className="flex space-x-2">
                          <div>{t('openClaim.cancellationReason')}</div>
                          <div
                            data-tip={t('openClaim.cancellationReasonText')}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
                              </svg>
                          </div>
                        </li>
                        <li className="flex space-x-2">
                          <div>{t('openClaim.ownerIdCard')}</div>
                          <div
                            data-tip={t('openClaim.ownerIdCardText')}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
                              </svg>
                          </div>
                        </li>
                      </ul>
                    </div>

                  <Dashboard hideUploadButton={true} uppy={uppy}></Dashboard>
                </FormField>

                <div>
                  <div className="text-gray-600 mb-4">
                    {t('openClaim.privacyInfo')} <a className="text-gray-700" href="https://refundandgo.com/privacy.pdf" target="_blank">{t('openClaim.privacyLink')}</a>
                  </div>
                </div>
                <Checkbox
                  label={t('openClaim.iAccept')}
                  onChange={() => setPrivacy(!privacy)}
                  checked={privacy}
                />
              </div>

              <div className="mt-6">
                <Button
                  className={'text-white bg-orange-600'}
                  onClick={handleSendClaim}
                  label={t('openClaim.askRefund')}
                  loading={sending}
                />
              </div>

              {
                (claimResponse && claimResponse.error) &&
                <div className="mt-4 rounded-md p-4 bg-red-100 text-red-800">
                  <div className="mb-2 font-bold text-red-800">Qualcosa è andato storto!</div>
                  <div>
                    {t('openClaim.claimError')}
                  </div>
                </div>
              }
            </div>
          </section>
        </>
      }

      <section className="p-8 bg-white rounded-lg my-10">
        <div className="flex space-x-2 items-center mb-2">
          <div><img className="w-12" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFdklEQVR4nO1bjVMUZRjn/8paULSBsFw+bvg6blAJJEarIRE48ISoMWPukA8DEhwKJQoUuAuzIcwcRULHSkFqCm0glWb6nKmpSZ/m99Yee58wcHvvsfv8Zp653b295/nt83u/792kJAaDwWAwGAwGg8FgMBgMBoPBYDAYDAbDUlBUH7H5DMsBC6DKLWAsgMoCWLqJS+I+wMcCyC6FCteA2CRhf9UJ2n/whPSkWrYJun6pgGYuFUjnYSkBCvf10fsDL9K1i3aiH58QhmNcs+/rk87PFAIcaToW8buUTC+NDVf4k68ZruG79fhkAdSVJDheOEX/PHgyamlOzvTS4u2d/uTjGNci3Q9f8AnfLECEhNa4PNTZ5aS5z3NEUmenc8R5tcsTthb8uZRMS7MZwnAcrvTjt/ABX/AJ3zhHrGiCWbIJqjnipr/vPxXQrOD80OGWkHt3FQ2Su6WRtmWPCsMxrgXfh9+G84lY3ASFEcFzvCEgWc3uVzecKPjQ+0QM7gMiJKu9o14k6afvdojP1jbXhpMFH3qfiMECREhWR0c91Ta4RfvsbHBTW/vhDScLPpz/+4RvxLC8AMUVvVRe2SU1EXoDF3CyTCc8MV5CU5NF0hOvGSZyEx+WmFuA3JLT9Fank7xny+nRwy2iPT4/WiaGhZjdxjvpiInY4AAu4ARu4AiuphMgJctLF8ZKQ2awU5NFtD1nJO4CpOaM0uWPi0P4TJ7fI4a2phNAE+HeV8/6H3b56zSRiHgnXy8COGh8wA0cTd0H/LKQSr/d3UY/L2ynv+4rhj/wagUCHMAFnMDN6JhSBcgoHKL+vkrxmZZ3lnp7DlH27jPSBEBscAAXPTfTCsDmYwEUyQWBa4BqYQF22j+QXgIVyRylCYCx9fxMlujwZCdZiWBP554THI0cGksRAA+krUqe6q2SMvFSVjFwAjdtFdYoEeIuwED/y/Ro+b+lB80eL28h37lyaf9K6Q0cwOVxEEdwBvdNL8DW7DGx+KZ/uOlP7bTDlji1AFzASc/xk/G9gvumFwBW19gc83+6lBhb8D9n4GxEHCkC9JysptvXbNR09Chd/6yAht87ID3hSpANDR4Q3MARXDFDNo0Awcu7Ri73KgnOUYoAbL7EEyDaLjYlzhZPLgkhQFVdS8JsFVSwbfG1Y3Sw7rh1BPjyai4tfPFcQtQCzAO+vamKjtfUAhSUvktXJhz0/a2VPZ1Lsxl0ddJBu+O0I0FviInY4KDxATdwBFfTCQBr9jSGzDh7DRrurcU6O+tCZuitbRvfi5SwAsC+uZHpf+Af5tKlJV8zcND4gJvR8aQKIHY1LybTzSt5NH3RLraCyFyYQ2xwABdwAjej+yWpAqTnDwWMNl6qbqddjtBdzUYs0oXzidjgoJ2DGziaVoC12shQRcxFMMKnKQWoqm8R7XFlbWvMfL7ibBU+Mf+Q/XwJK8Db3TV043I+/X5vq0gW9ungvKu7dt0+8Vv4gC/4hG+cIxYLEJQs297TtDT3TMCw8MGddMor6V93smx7zgSM84XP+TTKe964cf6mrQGK6qPG198ISJar6c2o9xeWvSMs2j3wofeJGDKfMaEF6DlZTX8sptAFb6kYEnZ3RW8qxkfKhEW7Bz7gCz7hGzFYgAjJqnZ5/C/bYYgY7gW9rOIBsZCHGTRePYXhGNfwXfD98KENdeE73FuXXAPUtSchPX+Ybk3ZQraV35nJNnxfp+mbIGWNhr1FD+dXtpXjOJH3G5lOAEX10a93U8U7vzAcy+ZjKQFUxyB9NFYq/reF4RjXZPOyjADKJjYWQGUBpJdChWuA/EQo3ATJTwb3Aar1bNVOmMFgMBgMBoPBYDAYDAaDwWAwGAwGg8FIMhP+BXfVlExprjUvAAAAAElFTkSuQmCC" /></div>
          <div className="text-2xl font-bold text-slate-700">
            {t('openClaim.privacyTitle')}
          </div>
        </div>
        <div className="text-lg text-slate-600 mt-1 mb-2">
          {t('openClaim.privacyRow1')}
        </div>
        <div className="text-lg text-slate-600 mt-1 mb-2">
          {t('openClaim.privacyRow2')}
        </div>
      </section>
    </div>
  )

}
